// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Lead = function Lead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lead-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.879 15.61a5 5 0 0 0-4.629-3.11h-2.5a5 5 0 0 0-4.629 3.11A8.124 8.124 0 0 1 10 1.875a8.124 8.124 0 0 1 5.879 13.733m-1.566 1.277A8.07 8.07 0 0 1 10 18.125a8.1 8.1 0 0 1-4.316-1.238 3.13 3.13 0 0 1 3.066-2.512h2.5a3.13 3.13 0 0 1 3.066 2.512zM10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20m0-10.625a1.562 1.562 0 1 1 0-3.125 1.562 1.562 0 0 1 0 3.125M6.563 7.813a3.438 3.438 0 1 0 6.875 0 3.438 3.438 0 0 0-6.876 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lead-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
